import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { useDispatch } from 'react-redux';
import { getGuestList } from 'cards/util/digitalSaveTheDate';
import Loader from 'components/common/ui/Loader';
import { toastsActions } from '@zola-helpers/client/dist/es/redux/toasts';
import styles from './styles.module.less';
import CopyGuestList from './CopyGuestList';
import DigitalCreateFreeGuestList from './DigitalCreateFreeGuestList';

interface GuestList {
  guest_groups: any[];
}

const GuestListLoader: React.FC = () => {
  const dispatch = useDispatch();
  const [guestList, setGuestList] = useState<null | GuestList>(null);

  useEffect(() => {
    getGuestList()
      .then((res: GuestList) => {
        if (typeof res === 'object') {
          setGuestList(res);
        }
      })
      .catch(() => {
        dispatch(toastsActions.negative({ headline: 'Failed to load guestList' }));
      });
  }, []);

  return (
    <>
      {!guestList && (
        <div className={cx(styles.container, styles.guestListLoader)}>
          <Loader />
        </div>
      )}
      {guestList && guestList.guest_groups.length > 0 && (
        <CopyGuestList initialGuestList={guestList} />
      )}
      {guestList && guestList.guest_groups.length === 0 && (
        <div className={cx(styles.container, styles.guestListLoader)}>
          <DigitalCreateFreeGuestList />
        </div>
      )}
    </>
  );
};

export default GuestListLoader;
